import { lazy } from "react";

import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const LotsPage = lazy(() =>
  import("@/pages/traceability/lots-page").then((m) => ({ default: m.LotsPage }))
);
const MassBalancePage = lazy(() =>
  import("@/pages/traceability/mass-balance-page").then((m) => ({ default: m.MassBalancePage }))
);
const OfClosurePage = lazy(() =>
  import("@/pages/traceability/of-closure-page").then((m) => ({ default: m.OfClosurePage }))
);
const RequestTcPage = lazy(() =>
  import("@/pages/traceability/request-tc-page").then((m) => ({ default: m.RequestTcPage }))
);

const ClientHistoryPage = lazy(() =>
  import("@/pages/traceability/client-history-page").then((m) => ({ default: m.ClientHistoryPage }))
);
const WarehousesPage = lazy(() =>
  import("@/pages/traceability/warehouses-page").then((m) => ({ default: m.WarehousesPage }))
);
const CertificatesPage = lazy(() =>
  import("@/pages/traceability/certificates-page").then((m) => ({ default: m.CertificatesPage }))
);
const CertificateDetailPage = lazy(() =>
  import("@/pages/traceability/certificate-detail-page").then((m) => ({ default: m.CertificateDetailPage }))
);
const LicensesPage = lazy(() =>
  import("@/pages/traceability/licenses-page").then((m) => ({ default: m.LicensesPage }))
);
const CertificateQueuePage = lazy(() =>
  import("@/pages/traceability/certificate-queue-page").then((m) => ({
    default: m.CertificateQueuePage,
  }))
);
const AlertsPage = lazy(() =>
  import("@/pages/traceability/alerts-page").then((m) => ({ default: m.AlertsPage }))
);
const DocumentsPage = lazy(() =>
  import("@/pages/traceability/documents-page").then((m) => ({ default: m.DocumentsPage }))
);
const CompliancePage = lazy(() =>
  import("@/pages/traceability/compliance-page").then((m) => ({ default: m.CompliancePage }))
);


const LOTS_READ = { access: "permission" as const, entity: "lots", action: "READ" };
const WAREHOUSES_READ = { access: "permission" as const, entity: "warehouses", action: "READ" };
const DyeingPage = lazy(() =>
  import("@/pages/traceability/dyeing-page").then((m) => ({ default: m.DyeingPage }))
);

const CERTIFICATES_READ = { access: "permission" as const, entity: "transaction_certificates", action: "READ" };
const LICENSES_READ = { access: "permission" as const, entity: "certification_licenses", action: "READ" };
const REQUESTS_READ = { access: "permission" as const, entity: "certificate_requests", action: "READ" };
const DYEING_READ = { access: "permission" as const, entity: "dyeing_orders", action: "READ" };
const ALERTS_READ = { access: "permission" as const, entity: "notification_rules", action: "READ" };
const DOCUMENTS_READ = { access: "permission" as const, entity: "trace_documents", action: "READ" };
const COMPLIANCE_READ = { access: "permission" as const, entity: "compliance_issues", action: "READ" };

export const traceabilityRoutes: RouteConfig[] = [
  { path: ROUTES.TRACEABILITY.LOTS, component: LotsPage, layout: "dashboard", permissions: LOTS_READ },
  // O balanço lê o mesmo ledger dos lotes — mesma entidade de permissão.
  { path: ROUTES.TRACEABILITY.MASS_BALANCE, component: MassBalancePage, layout: "dashboard", permissions: LOTS_READ },
  { path: ROUTES.TRACEABILITY.OF_CLOSURE, component: OfClosurePage, layout: "dashboard", permissions: LOTS_READ },
  { path: ROUTES.TRACEABILITY.CLIENT_HISTORY, component: ClientHistoryPage, layout: "dashboard", permissions: LOTS_READ },
  // Pedir o TC das faturas de um cliente: junta faturas, OFs e o repositório, mas a entrada é a mesma dos lotes.
  { path: ROUTES.TRACEABILITY.REQUEST_TC, component: RequestTcPage, layout: "dashboard", permissions: LOTS_READ },
  { path: ROUTES.TRACEABILITY.WAREHOUSES, component: WarehousesPage, layout: "dashboard", permissions: WAREHOUSES_READ },
  { path: ROUTES.TRACEABILITY.CERTIFICATES, component: CertificatesPage, layout: "dashboard", permissions: CERTIFICATES_READ },
  { path: ROUTES.TRACEABILITY.CERTIFICATE_DETAIL, component: CertificateDetailPage, layout: "dashboard", permissions: CERTIFICATES_READ },
  { path: ROUTES.TRACEABILITY.LICENSES, component: LicensesPage, layout: "dashboard", permissions: LICENSES_READ },
  { path: ROUTES.TRACEABILITY.CERTIFICATE_REQUESTS, component: CertificateQueuePage, layout: "dashboard", permissions: REQUESTS_READ },
  { path: ROUTES.TRACEABILITY.DYEING, component: DyeingPage, layout: "dashboard", permissions: DYEING_READ },
  // §4.8 — regras de notificação configuráveis.
  { path: ROUTES.TRACEABILITY.ALERTS, component: AlertsPage, layout: "dashboard", permissions: ALERTS_READ },
  // §4.5 — repositório documental.
  { path: ROUTES.TRACEABILITY.DOCUMENTS, component: DocumentsPage, layout: "dashboard", permissions: DOCUMENTS_READ },
  // §4.7 — ocorrências de conformidade.
  { path: ROUTES.TRACEABILITY.COMPLIANCE, component: CompliancePage, layout: "dashboard", permissions: COMPLIANCE_READ },
];
